import { ApiOrganization, Organization } from "../model";
import { httpClient, postProcessUpsert } from "@genai/http-client";
import { loadUser, User } from "@genai/user";

export interface LoaderData {
  organizations?: Organization[];
  user: User;
}

export const loadOrganizations = () =>
    httpClient(`/organizations`, {
      method: "GET",
    })
      .then(postProcessUpsert<ApiOrganization[]>)
      .then((organizations) => organizations as Organization[]);

export const organizationPageLoader = async (): Promise<LoaderData> => {
  const organizations = await loadOrganizations();
  const user = await loadUser();
  return { organizations, user };
};
